import cx from "classnames";
import React from "react";
import { getAuth, signInAnonymously } from "firebase/auth";
import About from "../About";
import FileCodeIcon from "./FileCodeIcon";
import FolderOpenIcon from "./FolderOpenIcon";
import Footer from "../Footer";
import Header from "../Header";
import MenuItem from "./MenuItem";
import More from "../More";
import Portfolio from "../Portfolio";
import Skills from "../Skills";
import firebase from "../../utils/firebase";
import HamburgerButton from "./HamburgerButton";
import Drawer from "../Drawer";
import ArrowToTopIcon from "./ArrowToTopIcon";
import InfoIcon from "./InfoIcon";
import EnvelopeIcon from "./EnvelopeIcon";
import "@awesome.me/webawesome/dist/components/button/button.js";

const Application: React.FC = (): React.ReactElement => {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    if (!firebase) return;
    // Sign in as an anonymous user
    const auth = getAuth(firebase);
    signInAnonymously(auth)
      .then(() => {
        console.log("Successfully signed in anonymously");
        return null;
      })
      .catch((error) => {
        console.error("Error signing in anonymously:", error);
      });
  }, []);

  const toggleMenu = React.useCallback(
    (event: React.MouseEvent): void => {
      if (event) {
        event.preventDefault();
      }
      setIsOpen(!isOpen);
    },
    [isOpen],
  );

  const onClickMenuButton = React.useCallback(
    (event: React.MouseEvent): void => toggleMenu(event),
    [toggleMenu],
  );

  const onClickMenuItem = React.useCallback(
    (event: React.MouseEvent): void => toggleMenu(event),
    [toggleMenu],
  );

  const closeDrawer = React.useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <div
      className={cx([
        "julia-website-application",
        "u-height-full",
        "u-width-full",
      ])}
    >
      <HamburgerButton isOpen={isOpen} onClick={onClickMenuButton} />

      <Drawer isOpen={isOpen} onClose={closeDrawer}>
        <MenuItem
          icon={
            <ArrowToTopIcon
              className="u-margin-bottom-3xs"
              fill="white"
              height={24}
            />
          }
          id="header"
          onClick={onClickMenuItem}
          text="Top"
        />
        <MenuItem
          icon={
            <InfoIcon
              className="u-margin-bottom-3xs"
              fill="white"
              height={24}
            />
          }
          id="about"
          onClick={onClickMenuItem}
          text="About"
        />
        <MenuItem
          icon={
            <FileCodeIcon
              className="u-margin-bottom-3xs"
              fill="white"
              height={24}
            />
          }
          id="skills"
          onClick={onClickMenuItem}
          text="Skills"
        />
        <MenuItem
          icon={
            <FolderOpenIcon
              className="u-margin-bottom-3xs"
              fill="white"
              height={24}
            />
          }
          id="samples"
          onClick={onClickMenuItem}
          text="Samples"
        />
        <MenuItem
          icon={
            <EnvelopeIcon
              className="u-margin-bottom-3xs"
              fill="white"
              height={24}
            />
          }
          id="footer"
          onClick={onClickMenuItem}
          text="Contact"
        />
      </Drawer>

      <Header />
      <About />
      <Skills />
      <Portfolio />
      <More />
      <Footer />
    </div>
  );
};

export default React.memo(Application);
